
// src/actions/comments.js

import api from './gamba-api'
import { emitAlertMessage, clearAlertMessage } from './alert-message'

export const POST_COMMENT = "POST_COMMENT"
export const POST_COMMENT_REQUESTED = "POST_COMMENT_REQUESTED"
export const POST_COMMENT_COMPLETED = "POST_COMMENT_COMPLETED"
export const POST_COMMENT_FAILED = "POST_COMMENT_FAILED"

export function postCommentRequested() {
  return {
    type: POST_COMMENT_REQUESTED
  }
}

export function postComment(type, id, comment, upload_files, upload_videos, mentions, reply_requested) {
  return function(dispatch) {
    dispatch(postCommentRequested())
    return api.post(`/comments`, { [type]: id, comment, upload_files, upload_videos, mentions, reply_requested }).then((results)=> {
      dispatch(postCommentCompleted(results))
    }).catch((error)=> {
      Promise.all([
        dispatch(postCommentFailed(error)),
        dispatch(emitAlertMessage(error, 'error'))
      ])
    })
  }
}

export function postCommentCompleted(results) {
  return {
    type: POST_COMMENT_COMPLETED,
    results,
  }
}

export function postCommentFailed(error) {
  return {
    type: POST_COMMENT_FAILED,
    error,
  }
}

export const PUT_COMMENT = "PUT_COMMENT"
export const PUT_COMMENT_REQUESTED = "PUT_COMMENT_REQUESTED"
export const PUT_COMMENT_COMPLETED = "PUT_COMMENT_COMPLETED"
export const PUT_COMMENT_FAILED = "PUT_COMMENT_FAILED"

export function putCommentRequested() {
  return {
    type: PUT_COMMENT_REQUESTED
  }
}

export function putComment(comment_id, comment, upload_files, upload_videos, mentions, reply_requested) {
  return function(dispatch) {
    dispatch(putCommentRequested())
    return api.put(`/comments/${comment_id}`, { comment, upload_files, upload_videos, mentions, reply_requested }).then((results)=> {
      dispatch(putCommentCompleted(results))
    }).catch((error)=> {
      Promise.all([
        dispatch(putCommentFailed(error)),
        dispatch(emitAlertMessage(error, 'error'))
      ])
    })
  }
}

export function putCommentCompleted(results) {
  return {
    type: PUT_COMMENT_COMPLETED,
    results,
  }
}

export function putCommentFailed(error) {
  return {
    type: PUT_COMMENT_FAILED,
    error,
  }
}

export const DELETE_COMMENT = "DELETE_COMMENT"
export const DELETE_COMMENT_REQUESTED = "DELETE_COMMENT_REQUESTED"
export const DELETE_COMMENT_COMPLETED = "DELETE_COMMENT_COMPLETED"
export const DELETE_COMMENT_FAILED = "DELETE_COMMENT_FAILED"

export function deleteCommentRequested() {
  return {
    type: DELETE_COMMENT_REQUESTED
  }
}

export function deleteComment(comment_id) {
  return function(dispatch) {
    dispatch(deleteCommentRequested())
    return api.delete(`/comments/${comment_id}`)
        .then((results)=> {
          dispatch(deleteCommentCompleted(results))
        })
        .catch((error)=> {
          Promise.all([
            dispatch(deleteCommentFailed(error)),
            dispatch(emitAlertMessage(error, 'error'))
          ])
        })
  }
}

export function deleteCommentCompleted(results) {
  return {
    type: DELETE_COMMENT_COMPLETED,
    results,
  }
}

export function deleteCommentFailed(error) {
  return {
    type: DELETE_COMMENT_FAILED,
    error,
  }
}



// WEBPACK FOOTER //
// ./src/actions/comments.js